import Main from "./nengajo/main.es6";

const main = new Main();